import React, { useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { store } from './reducer';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  operatorsSettings: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Main = () => {
  useTitle("تنظیمات کارشناسان حمل")
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { dispatch } = useContext(store);

  const handleGoToCategories = () => history.push(`${path}/categories`);
  const handleGoToRules = () => history.push(`${path}/rules`);

  useEffect(() => {
    dispatch({
      type: 'CHANGE_TITLE_SUBTITLE',
      payload: { title: 'تنظیمات کارشناسان حمل', subtitle: '' },
    });
  }, []);

  return (
    <div className={classes.operatorsSettings}>
      <List>
        <ListItem button onClick={handleGoToCategories}>
          <ListItemText
            primary="مدیریت نقش‌ها"
            secondary="جهت افزودن،حذف و ویرایش نقش‌ها"
          />
        </ListItem>
        <ListItem button onClick={handleGoToRules}>
          <ListItemText
            primary="مدیریت عملکردها"
            secondary="جهت افزودن، ویرایش و حذف عملکردهایی که یک کارشناس حمل بالقوه میتواند انجام دهد."
          />
        </ListItem>
      </List>
    </div>
  );
};

export default React.memo(Main);
